import { connect } from 'react-redux';
import AppWrap from './AppWrap';

const mapStateToProps = (state) => {
  return {
    metadata: state.metadataReducer,
  };
};

export default connect(mapStateToProps, null)(AppWrap);
